import { atom } from 'jotai';

import {
  authCacheSuppressedAtom,
  authSessionMetadataAtom,
  authStateAtom,
  authTransientFailureAtom,
  authUnauthenticatedReasonAtom,
  keycloakSessionBridgeAtom,
  kindeDesktopBridgeAtom,
} from './atoms';

/**
 * Read-only atom views are the primary state-door surface for atom
 * derivations. Legacy app writers temporarily use the base atoms listed in
 * `LEGACY-ATOM-EXPORTS.md`.
 */
export const authStateReadAtom = atom((get) => get(authStateAtom));
export const authUnauthenticatedReasonReadAtom = atom((get) =>
  get(authUnauthenticatedReasonAtom)
);
export const authSessionMetadataReadAtom = atom((get) => get(authSessionMetadataAtom));
export const authTransientFailureReadAtom = atom((get) => get(authTransientFailureAtom));
export const kindeDesktopBridgeReadAtom = atom((get) => get(kindeDesktopBridgeAtom));
export const authCacheSuppressedReadAtom = atom((get) => get(authCacheSuppressedAtom));
export const keycloakSessionBridgeReadAtom = atom((get) =>
  get(keycloakSessionBridgeAtom)
);
